import { cn } from "@/lib/utils";
/** Tiny server-renderable building blocks shared by the use-case pages. */

export const logo = (app: string) => `/landing-d6/logos/${app}.svg`;

export function AppIcon({ app, lg }: { app: string; lg?: boolean }) {
  return (
    <i className={lg ? "app lg" : "app"}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={logo(app)} alt="" loading="lazy" decoding="async" />
    </i>
  );
}

export function AppRow({ apps }: { apps: string[] }) {
  return (
    <span className="apps">
      {apps.map((a) => (
        <AppIcon key={a} app={a} />
      ))}
    </span>
  );
}

/**
 * The engine faces from the landing's close-marks: Bash's peaked eyes on
 * copper, Nami's wavy eyes on slate. The .fe group blinks (faceBlink).
 */
export function EngineMark({
  kind,
  size,
}: {
  kind: "bash" | "nami";
  size?: "sm";
}) {
  return (
    <span className={cn("em em-", kind, size ? ` em-${size}` : "")}>
      {kind === "bash" ? (
        <svg viewBox="15.5 7.5 33 24.5">
          <g className="fe">
            <path d="M18 17 L24 10 L30 17" />
            <path d="M34 17 L40 10 L46 17" />
          </g>
          <path d="M24 26 Q32 33 40 26" />
        </svg>
      ) : (
        <svg viewBox="15.5 7.5 33 24.5">
          <g className="fe">
            <path d="M18 14 Q21 10.5 24 14 T30 14" />
            <path d="M34 14 Q37 10.5 40 14 T46 14" />
          </g>
          <path d="M24 26 Q32 33 40 26" />
        </svg>
      )}
    </span>
  );
}

export function BashMark() {
  return (
    <span className="bm">
      <svg viewBox="15.5 7.5 33 24.5">
        <path d="M18 17 L24 10 L30 17" />
        <path d="M34 17 L40 10 L46 17" />
        <path d="M24 26 Q32 33 40 26" />
      </svg>
    </span>
  );
}
